import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "It is a feature that allows you to view information on lock accesses that were shared to other users. It displays important information such as access history, access method, date, time, and location when accessed.",
    more: "Instructions",
    back: "Back",
  },
  ja: {
    reply1:
      "他のユーザーに共有されたロックアクセス情報を閲覧できる機能です。アクセス履歴、アクセス方法、アクセス日時、アクセス時の場所などの重要な情報が表示されます。",
    more: "説明書",
    back: "戻る",
  },
  es: {
    reply1:
      "Es una función que le permite ver información sobre los accesos a bloqueos que se compartieron con otros usuarios. Muestra información importante como el historial de acceso, el método de acceso, la fecha, la hora y la ubicación cuando se accede.",
    more: "Instrucciones",
    back: "Atrás",
  },
});

class GrantAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "instruction_qns", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "instruction_qns",
          trigger: "instruction_qns",
        });
      });
    }
  };

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "instruction_qns" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick}
            disabled={clicked}
          >
            {localizationStrings.more}
          </button>
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default GrantAccess;
